import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '9.075 6.5387'
  const rightTransformOrigin = '38.9299 6.5387'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M0.38994 10.3888L18.5399 9.72876L17.9499 4.7688L0.189941 5.59875L0.38994 10.3888Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path d="M0.190001 6.5387L18.15 5.87872L17.56 0.928711L0 1.74872L0.190001 6.5387Z" fill={fill} />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M47.6099 10.3888L29.4199 9.72876L29.9999 4.7688L47.8099 5.59875L47.6099 10.3888Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path d="M47.8099 6.5387L29.8599 5.87872L30.4399 0.928711L47.9999 1.74872L47.8099 6.5387Z" fill={fill} />
      </g>
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="9.36504"
          y1="11.3607"
          x2="9.36504"
          y2="6.2536"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
          <stop offset="0.8775" stopColor={gradient[0]} stopOpacity=".5" />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="38.615"
          y1="11.3607"
          x2="38.615"
          y2="6.2536"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
          <stop offset="0.8775" stopColor={gradient[0]} stopOpacity=".5" />
        </linearGradient>
      </defs>
    </g>
  )
}
